import {Component, Inject, OnInit, signal} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'lib-ok-dialog',
    templateUrl: './ok-dialog.component.html',
    styleUrls: ['./ok-dialog.component.css'],
    standalone: false
})
export class OkDialogComponent implements OnInit
{
    protected title = signal('OK');

    constructor(
        public dialogRef: MatDialogRef<OkDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        if (this.data.title) {
            this.title.set(this.data.title);
        }
    }

}
